import { render, staticRenderFns } from "./start-today.vue?vue&type=template&id=a8871494&scoped=true"
import script from "./start-today.vue?vue&type=script&lang=js"
export * from "./start-today.vue?vue&type=script&lang=js"
import style0 from "./start-today.vue?vue&type=style&index=0&id=a8871494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8871494",
  null
  
)

export default component.exports